// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headerLogo{display:inline-block;text-align:center;margin-right:20px;margin-top:5px}.headerLogo img{width:50px;height:50px;margin-bottom:-5px}@media (max-width: 768px){.headerLogo{display:none}}\n", ""]);
// Exports
module.exports = exports;
